import { SafeStyle } from '@angular/platform-browser'

export class ChartModel {

    constructor() { }

    id: string
    tit: string
    dsc: string
    dis: number
    grp: number
    sty: string
    cls: string
    styp: string
    clsp: string
    srt: number
    lod: boolean
    pars: any[][] //  [ fk_nam: string, parent_id: number, parent_nam: string, auto_referesh: boolean, row_id: number, ]
    cnf: any
    prm: { key: string, val: any }[]
    ctyp: string
    canvas: any
    ctx: any
    ssty: SafeStyle
    chart: any // fill after inial chart

}